import { takeLatest, call } from "redux-saga/effects";
import { createEntitySaga } from "./apiSagas.js";

import { SIGNUP } from "../actions/actionConstants.js";

export function* signUpCreateSaga(action) {
  try {
    yield call(createEntitySaga, SIGNUP, undefined, action);
  } catch (error) {
    console.log("signUpCreateSaga :: ERROR ::", error);
  }
}

// -- WATCHERS -- //

export function* watchSignUpSagas() {
  yield takeLatest(SIGNUP.POST, signUpCreateSaga);
}
